import React, { useEffect, useState } from "react";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import { useNavigate } from "react-router-dom";
import { courseList } from "../../api/Courses";
import { LoadingDiv, SweetAlertShow } from "../master/Master";
import { districtsList, statesList } from "../../api/Locations";
import { StaffList } from "../../api/Staff";
import { enquiryAdd, enquiryNoVerify } from "../../api/Enquiry";
import Master from "./Master";
import useAppConfig from "../config/useAppConfig";

export default function EnquiryAdd() {
  const config = useAppConfig("Enquiry", "enquiry_fields");
  const navigate = useNavigate();
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [staffs, setStaffs] = useState([]);
  const [data, setData] = useState([]);
  const [enquiryNoData, setEnquiryNoData] = useState({
    enquiry_no: false,
    enquiry: "",
  });
  const [sessions, setSessions] = useState([]);
  const [setting, setSetting] = useState({});

  useEffect(() => {
    setSetting(JSON.parse(localStorage.getItem("setting") ?? "{}"));
    setSessions(JSON.parse(localStorage.getItem("sessions") ?? "[]"));
  }, []);

  useEffect(() => {
    setData({
      ...data,
      session_id: sessions?.find((s) => s?.status === "1")?.id,
    });
  }, [sessions]);

  const getEnquiryNo = async () => {
    setLoading(true);
    try {
      let addUrl = "";
      if (enquiryNoData?.enquiry_no) {
        addUrl += `enquiry_no=${enquiryNoData?.enquiry_no}`;
      }
      const response = await enquiryNoVerify(addUrl);
      if (response.data.status) {
        if (enquiryNoData?.enquiry_no === false) {
          setEnquiryNoData({
            ...enquiryNoData,
            enquiry_no: response?.data?.data?.next_enquiry_no,
          });
        }
        if (response.data.data?.enquiry) {
          setEnquiryNoData({
            ...enquiryNoData,
            enquiry: response?.data?.data?.enquiry,
          });
        }
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message
      );
    } finally {
      setLoading(false);
    }
  };
  const getCourseData = async () => {
    setLoading(true);
    try {
      const response = await courseList();
      if (response.data.status) {
        setCourses(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message
      );
    } finally {
      setLoading(false);
    }
  };

  const getStates = async () => {
    setLoading(true);
    try {
      const response = await statesList();
      if (response.data.status === true) {
        setStates(response.data.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message
      );
    } finally {
      setLoading(false);
    }
  };

  const getDistricts = async (state = null) => {
    setLoading(true);
    try {
      let addUrl = "";
      if (state) addUrl += `&state=${state}`;
      const response = await districtsList(addUrl);
      if (response.data.status === true) {
        setDistricts(response.data.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message
      );
    } finally {
      setLoading(false);
    }
  };

  const getStaffs = async () => {
    const addUrl = `status=1`;
    setLoading(true);
    try {
      const response = await StaffList(addUrl);
      if (response.data.status) {
        setStaffs(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getStates();
    getDistricts();
    getCourseData();
    getStaffs();
  }, []);

  useEffect(() => {
    if (data?.state) {
      getDistricts(data?.state);
    }
  }, [data?.state]);

  useEffect(() => {
    getEnquiryNo();
  }, [enquiryNoData?.enquiry_no]);

  const handleAdd = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData(e.target);
      const response = await enquiryAdd(formData);
      if (response?.data?.status) {
        SweetAlertShow("success", "Successfully", response?.data?.message);
        navigate("/enquiry");
      } else {
        SweetAlertShow("info", "warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message
      );
    } finally {
      setLoading(false);
    }
  };

  const fieldConfig = (() => {
    try {
      return JSON.parse(config?.value || "[]");
    } catch {
      return [];
    }
  })();

  const getField = (name) => {
    return (
      fieldConfig.find((f) => f.field === name) || {
        show: 1,
        required: 0,
      }
    );
  };
  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="row">
                  <Master />
                  <div className="col-12">
                    <div className="card">
                      <div className="card-body">
                        <h4 className="text-primary m-0">Add Enquiry</h4>
                        <hr />
                        <form action="" onSubmit={handleAdd}>
                          <div className="row g-3">
                            <div className="col-12">
                              <h5 className="text-primary fw-semibold m-0">
                                Basic Details
                              </h5>
                            </div>
                            <div className="col-sm-6">
                              <div className="form-floating form-floating-outline">
                                <select
                                  name="session_id"
                                  className="form-control"
                                  value={data?.session_id}
                                  onChange={(e) => {
                                    setData({
                                      ...data,
                                      session_id: e.target.value,
                                    });
                                  }}
                                  required
                                >
                                  <option value="">Select Session</option>
                                  {sessions?.map((session, i) => (
                                    <option key={i} value={session?.id}>
                                      {session?.session}
                                    </option>
                                  ))}
                                </select>
                                <label>
                                  Session <span className="text-danger">*</span>
                                </label>
                              </div>
                            </div>
                            <div className="col-sm-6">
                              <div className="form-floating form-floating-outline">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="enquiry_no"
                                  placeholder="Enquiry No"
                                  value={enquiryNoData?.enquiry_no}
                                  onChange={(e) =>
                                    setEnquiryNoData({
                                      ...enquiryNoData,
                                      enquiry_no: e.target.value,
                                    })
                                  }
                                  required
                                />
                                <label>
                                  Enquiry No
                                  <span className="text-danger">*</span>
                                </label>
                              </div>
                            </div>
                            <div className="col-sm-6">
                              <div className="form-floating form-floating-outline">
                                <input
                                  type="text"
                                  className="form-control input-uppercase"
                                  name="student_name"
                                  placeholder="Student Name"
                                  value={data?.student_name}
                                  onChange={(e) => {
                                    setData({
                                      ...data,
                                      student_name:
                                        e.target.value,
                                    });
                                  }}
                                  required
                                />
                                <label>
                                  Student Name{" "}
                                  <span className="text-danger">*</span>
                                </label>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-floating form-floating-outline">
                                <select
                                  className="form-select"
                                  name="course_id"
                                  required
                                  value={data?.course_id}
                                  onChange={(e) => {
                                    setData({
                                      ...data,
                                      course_id: e.target.value,
                                    });
                                  }}
                                >
                                  <option value="">Select Course</option>
                                  {courses?.map((course, i) => (
                                    <option key={i} value={course.id}>
                                      {course.title}
                                    </option>
                                  ))}
                                </select>

                                <label>
                                  Course <span className="text-danger">*</span>
                                </label>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="form-floating form-floating-outline">
                                <input
                                  className="form-control"
                                  name="mobile"
                                  placeholder="Search Student"
                                  value={data?.mobile}
                                  onChange={(e) => {
                                    setData({
                                      ...data,
                                      mobile: e.target.value,
                                    });
                                  }}
                                  maxLength={10}
                                  minLength={10}
                                  required
                                />
                                <label>
                                  Mobile <span className="text-danger">*</span>
                                </label>
                              </div>
                            </div>
                            {getField("secondary_mobile").show === 1 && (
                              <div className="col-sm-6">
                                <div className="form-floating form-floating-outline">
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="secondary_mobile"
                                    placeholder="Secondary Mobile No "
                                    required={
                                      getField("secondary_mobile").required ===
                                      1
                                    }
                                  />
                                  <label>
                                    Secondary Mobile No{" "}
                                    {getField("secondary_mobile").required ===
                                      1 && (
                                      <span className="text-danger">*</span>
                                    )}
                                  </label>
                                </div>
                              </div>
                            )}

                            {getField("father_name").show === 1 && (
                              <div className="col-md-6">
                                <div className="form-floating form-floating-outline">
                                  <input
                                    type="text"
                                    className="form-control input-uppercase"
                                    name="father_name"
                                    placeholder="Father's Name"
                                    onChange={(e) => {
                                      setData({
                                        ...data,
                                        father_name: e.target.value,
                                      });
                                    }}
                                    required={
                                      getField("father_name").required === 1
                                    }
                                  />
                                  <label>
                                    Father's Name
                                    {getField("father_name").required === 1 && (
                                      <span className="text-danger">*</span>
                                    )}
                                  </label>
                                </div>
                              </div>
                            )}
                            {getField("email").show === 1 && (
                              <div className="col-sm-6">
                                <div className="form-floating form-floating-outline">
                                  <input
                                    type="email"
                                    className="form-control"
                                    name="email"
                                    placeholder="Email"
                                    required={getField("email").required === 1}
                                  />
                                  <label>
                                    Email
                                    {getField("email").required === 1 && (
                                      <span className="text-danger">*</span>
                                    )}
                                  </label>
                                </div>
                              </div>
                            )}
                            {getField("category").show === 1 && (
                              <div className="col-md-6">
                                <div className="form-floating form-floating-outline">
                                  <select
                                    name="category"
                                    className="form-control"
                                    required={
                                      getField("category").required === 1
                                    }
                                  >
                                    <option value="">Select Category</option>
                                    <option value="GEN">GEN</option>
                                    <option value="EWS">EWS</option>
                                    <option value="OBC">OBC</option>
                                    <option value="SC">SC</option>
                                    <option value="ST">ST</option>
                                    <option value="MBC">MBC</option>
                                  </select>
                                  <label>
                                    Category
                                    {getField("category").required === 1 && (
                                      <span className="text-danger">*</span>
                                    )}
                                  </label>
                                </div>
                              </div>
                            )}
                            {getField("gender").show === 1 && (
                              <div className="col-sm-6">
                                <div className="form-floating form-floating-outline">
                                  <select
                                    className="form-select"
                                    name="gender"
                                    required={getField("gender").required === 1}
                                  >
                                    <option value="">Select Gender</option>
                                    <option value="Male">Male</option>
                                    <option value="Female">Female</option>
                                    <option value="Other">Other</option>
                                  </select>
                                  <label>
                                    Gender
                                    {getField("gender").required === 1 && (
                                      <span className="text-danger">*</span>
                                    )}
                                  </label>
                                </div>
                              </div>
                            )}
                            {getField("hostel_status").show === 1 && (
                              <div className="col-md-6">
                                <div className="form-floating form-floating-outline">
                                  <select
                                    name="hostel_status"
                                    className="form-control"
                                    required={
                                      getField("hostel_status").required === 1
                                    }
                                  >
                                    <option value="">Select Hostel</option>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                  </select>
                                  <label>
                                    Hostel
                                    {getField("hostel_status").required ===
                                      1 && (
                                      <span className="text-danger">*</span>
                                    )}
                                  </label>
                                </div>
                              </div>
                            )}
                            {getField("medium").show === 1 && (
                              <div className="col-md-6">
                                <div className="form-floating form-floating-outline">
                                  <select
                                    name="medium"
                                    className="form-control"
                                    required={getField("medium").required === 1}
                                  >
                                    <option value="">Select Medium</option>
                                    <option value="Hindi">Hindi</option>
                                    <option value="English">English</option>
                                  </select>
                                  <label>
                                    Medium
                                    {getField("medium").required === 1 && (
                                      <span className="text-danger">*</span>
                                    )}
                                  </label>
                                </div>
                              </div>
                            )}
                            {getField("counselor_id").show === 1 && (
                              <div className="col-md-6">
                                <div className="form-floating form-floating-outline">
                                  <select
                                    name="counselor_id"
                                    className="form-control"
                                    required={
                                      getField("counselor_id").required === 1
                                    }
                                  >
                                    <option value="">Select Staff</option>
                                    {staffs?.map((staff, i) => (
                                      <option key={i} value={staff?.id}>
                                        {staff?.name} ({staff?.registration_no})
                                      </option>
                                    ))}
                                  </select>
                                  <label>
                                    {" "}
                                    Assign Staff
                                    {getField("counselor_id").required ===
                                      1 && (
                                      <span className="text-danger">*</span>
                                    )}
                                  </label>
                                </div>
                              </div>
                            )}
                            {getField("enquiry_date").show === 1 && (
                              <div className="col-md-6">
                                <div className="form-floating form-floating-outline">
                                  <input
                                    type="date"
                                    className="form-control"
                                    name="enquiry_date"
                                    value={
                                      data?.enquiry_date ||
                                      new Date(
                                        new Date().setDate(
                                          new Date().getDate() + 0
                                        )
                                      )
                                        .toISOString()
                                        .split("T")[0]
                                    }
                                    onChange={(e) =>
                                      setData({
                                        ...data,
                                        enquiry_date: e.target.value,
                                      })
                                    }
                                    required={
                                      getField("enquiry_date").required === 1
                                    }
                                  />
                                  <label>
                                    Enquiry Date
                                    {getField("enquiry_date").required ===
                                      1 && (
                                      <span className="text-danger">*</span>
                                    )}
                                  </label>
                                </div>
                              </div>
                            )}
                            {getField("last_eduction").show === 1 && (
                              <div className="col-md-6">
                                <div className="form-floating form-floating-outline">
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="last_eduction"
                                    placeholder="Last Education"
                                    required={
                                      getField("last_eduction").required === 1
                                    }
                                  />
                                  <label>
                                    Last Education
                                    {getField("last_eduction").required ===
                                      1 && (
                                      <span className="text-danger">*</span>
                                    )}
                                  </label>
                                </div>
                              </div>
                            )}
                            {getField("last_institute_name").show === 1 && (
                              <div className="col-md-6">
                                <div className="form-floating form-floating-outline">
                                  <input
                                    type="text"
                                    className="form-control input-uppercase"
                                    name="last_institute_name"
                                    placeholder="Last Institute Name"
                                    required={
                                      getField("last_institute_name")
                                        .required === 1
                                    }
                                  />
                                  <label>
                                    Last Institute Name
                                    {getField("last_institute_name")
                                      .required === 1 && (
                                      <span className="text-danger">*</span>
                                    )}
                                  </label>
                                </div>
                              </div>
                            )}
                            {(getField("village").show === 1 ||
                              getField("state").show === 1 ||
                              getField("district").show === 1) && (
                              <div className="col-12">
                                <hr />
                                <h5 className="text-primary fw-bold">
                                  Address
                                </h5>
                              </div>
                            )}
                            {getField("village").show === 1 && (
                              <div className="col-md-6">
                                <div className="form-floating form-floating-outline">
                                  <input
                                    type="text"
                                    className="form-control input-uppercase"
                                    name="village"
                                    placeholder="Village/Town"
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      e.target.value = value
                                        .split(" ")
                                        .map(
                                          (word) =>
                                            word.charAt(0).toUpperCase() +
                                            word.slice(1).toLowerCase()
                                        )
                                        .join(" ");
                                    }}
                                    required={
                                      getField("village").required === 1
                                    }
                                  />
                                  <label>
                                    Village/Town{" "}
                                    {getField("village").required === 1 && (
                                      <span className="text-danger">*</span>
                                    )}
                                  </label>
                                </div>
                              </div>
                            )}
                            {getField("state").show === 1 && (
                              <div className="col-md-6">
                                <div className="form-floating form-floating-outline">
                                  <select
                                    className="form-select"
                                    name="state"
                                    value={data?.state}
                                    onChange={(e) =>
                                      setData({
                                        ...data,
                                        state: e.target.value,
                                      })
                                    }
                                    required={getField("state").required === 1}
                                  >
                                    <option>Select State </option>
                                    {states?.map((state) => (
                                      <option key={state.id} value={state.name}>
                                        {state.name}
                                      </option>
                                    ))}
                                  </select>
                                  <label>
                                    State{" "}
                                    {getField("state").required === 1 && (
                                      <span className="text-danger">*</span>
                                    )}
                                  </label>
                                </div>
                              </div>
                            )}
                            {getField("district").show === 1 && (
                              <div className="col-md-6">
                                <div className="form-floating form-floating-outline">
                                  <select
                                    className="form-select"
                                    name="district"
                                    required={
                                      getField("district").required === 1
                                    }
                                  >
                                    <option value="">Select District</option>
                                    {districts?.map((district) => (
                                      <option
                                        key={district.id}
                                        value={district.name}
                                      >
                                        {district.name}
                                      </option>
                                    ))}
                                  </select>
                                  <label>
                                    District{" "}
                                    {getField("district").required === 1 && (
                                      <span className="text-danger">*</span>
                                    )}
                                  </label>
                                </div>
                              </div>
                            )}
                            {getField("pincode").show === 1 && (
                              <div className="col-md-6">
                                <div className="form-floating form-floating-outline">
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="pincode"
                                    placeholder="Pin Code"
                                    maxLength={6}
                                    onInput={(e) =>
                                      (e.target.value = e.target.value.replace(
                                        /\D/g,
                                        ""
                                      ))
                                    }
                                    required={
                                      getField("pincode").required === 1
                                    }
                                  />
                                  <label>
                                    Pin Code{" "}
                                    {getField("pincode").required === 1 && (
                                      <span className="text-danger">*</span>
                                    )}
                                  </label>
                                </div>
                              </div>
                            )}
                            {(getField("next_followup_date").show === 1 ||
                              getField("source").show === 1 ||
                              getField("note").show === 1 ||
                              getField("reference_detail").show === 1) && (
                              <div className="col-12">
                                <hr />
                                <h5 className="text-primary fw-bold">
                                  Additional Details
                                </h5>
                              </div>
                            )}

                            {getField("next_followup_date").show === 1 && (
                              <div className="col-md-6">
                                <div className="form-floating form-floating-outline">
                                  <input
                                    type="date"
                                    className="form-control"
                                    name="next_followup_date"
                                    value={
                                      data?.next_followup_date ||
                                      new Date(
                                        new Date().setDate(
                                          new Date().getDate() + 1
                                        )
                                      )
                                        .toISOString()
                                        .split("T")[0]
                                    }
                                    onChange={(e) =>
                                      setData({
                                        ...data,
                                        next_followup_date: e.target.value,
                                      })
                                    }
                                    required={
                                      getField("next_followup_date")
                                        .required === 1
                                    }
                                  />
                                  <label>
                                    Next FollowUp Date{" "}
                                    {getField("next_followup_date").required ===
                                      1 && (
                                      <span className="text-danger">*</span>
                                    )}
                                  </label>
                                </div>
                              </div>
                            )}
                            {getField("note").show === 1 && (
                              <div className="col-md-6">
                                <div className="form-floating form-floating-outline">
                                  <textarea
                                    className="form-control input-uppercase"
                                    name="note"
                                    placeholder="Response"
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      e.target.value = value
                                        .split(" ")
                                        .map(
                                          (word) =>
                                            word.charAt(0).toUpperCase() +
                                            word.slice(1).toLowerCase()
                                        )
                                        .join(" ");
                                    }}
                                    required={getField("note").required === 1}
                                  />
                                  <label>
                                    Response
                                    {getField("note").required === 1 && (
                                      <span className="text-danger">*</span>
                                    )}
                                  </label>
                                </div>
                              </div>
                            )}
                            {getField("reference_detail").show === 1 && (
                              <div className="col-md-6">
                                <div className="form-floating form-floating-outline">
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="reference_detail"
                                    placeholder="Reference Detail"
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      e.target.value = value
                                        .split(" ")
                                        .map(
                                          (word) =>
                                            word.charAt(0).toUpperCase() +
                                            word.slice(1).toLowerCase()
                                        )
                                        .join(" ");
                                    }}
                                    required={
                                      getField("reference_detail").required ===
                                      1
                                    }
                                  />
                                  <label>
                                    Reference Detail
                                    {getField("reference_detail").required ===
                                      1 && (
                                      <span className="text-danger">*</span>
                                    )}
                                  </label>
                                </div>
                              </div>
                            )}
                            {getField("source").show === 1 && (
                              <div className="col-md-6">
                                <div className="form-floating form-floating-outline">
                                  <select
                                    name="source"
                                    className="form-control"
                                    required={getField("source").required === 1}
                                  >
                                    <option value="">Select Source</option>
                                    <option value="Home Visit">
                                      Home Visit
                                    </option>
                                    <option value="Institute Visit">
                                      Institute Visit
                                    </option>
                                    <option value="School Visit">
                                      School Visit
                                    </option>
                                    <option value="Calling">Calling</option>
                                    <option value="Visiting">Visiting</option>
                                    <option value="Just Dial">Just dial</option>
                                    <option value="WhatsApp">WhatsApp</option>
                                    <option value="Instagram">Instagram</option>
                                    <option value="Facebook">Facebook</option>
                                    <option value="Website">Website</option>
                                    <option value="Friend Reference">
                                      Friend Reference
                                    </option>
                                    <option value="Other">Other</option>
                                  </select>
                                  <label>
                                    Student Source
                                    {getField("source").required === 1 && (
                                      <span className="text-danger">*</span>
                                    )}
                                  </label>
                                </div>
                              </div>
                            )}

                            {setting?.message_status === "Yes" && (
                              <div className="col-md-12">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="sendMessage"
                                    name="sendMessage"
                                    defaultChecked={true}
                                    value={1}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="sendMessage"
                                  >
                                    Send Message
                                  </label>
                                </div>
                              </div>
                            )}

                            <div className="d-flex justify-content-end gap-2">
                              <button
                                type="submit"
                                className="btn btn-primary px-5"
                                disabled={loading}
                              >
                                {loading ? (
                                  <span
                                    className="spinner-border spinner-border-sm"
                                    role="status"
                                    aria-hidden="true"
                                  ></span>
                                ) : (
                                  "Submit"
                                )}
                                {loading ? " Submitting..." : ""}
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
